<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <g clip-path="url(#hide__a)">
    <path fill-rule="evenodd" d="M16.377 5.113C15.015 4.436 13.54 4 12 4 6.78 4 2.308 9.01.444 11.443a2.112 2.112 0 0 0 0 2.591c.743.97 1.9 2.35 3.355 3.658l4.485-4.485a3.745 3.745 0 0 1 4.184-4.184l3.91-3.91Zm-5.463 11.21a3.745 3.745 0 0 0 4.671-4.671l4.218-4.217c1.642 1.407 2.944 2.95 3.753 4.008a2.114 2.114 0 0 1 0 2.591c-1.864 2.433-6.335 7.443-11.556 7.443-1.727 0-3.373-.549-4.869-1.37l3.783-3.784Z"/>
    <path d="m20 3 1.414 1.414L3.383 22.445l-1.414-1.414z"/>
  </g>
  <defs>
    <clipPath id="hide__a">
      <path d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
